export default "__VITE_ASSET__Bvgonc6C__"